// API Configuration - Maps all backend routes exactly as defined in BE/Routes
const API_BASE_URL = "https://new-restro.vercel.app";

// Auth endpoints - BE/Routes/AuthRouter.js
export const AUTH = {
  LOGIN: `${API_BASE_URL}/auth/login`,
  SIGNUP: `${API_BASE_URL}/auth/signup`,
};

// User endpoints (customer) - BE/Routes/UserRouters.js
export const USER = {
  MENU_ITEMS: `${API_BASE_URL}/user/menuitems`,
  PLACE_ORDER: `${API_BASE_URL}/user/placeorder`,
  PENDING_ORDER: `${API_BASE_URL}/user/pendingorder`,
  PAY_ORDER: `${API_BASE_URL}/user/payorder`,
  VERIFY: `${API_BASE_URL}/user/verify`,
};

// Manager endpoints - BE/Routes/ManagerRouters.js
export const MANAGER = {
  MENU_ITEMS: `${API_BASE_URL}/manager/menuitems`,
  PLACE_ORDER: `${API_BASE_URL}/manager/placeorder`,
  PENDING_ORDER: `${API_BASE_URL}/manager/pendingorder`,
  PAY_ORDER: (orderId) => `${API_BASE_URL}/manager/payorder/${orderId}`,
  NOTIFICATIONS: `${API_BASE_URL}/manager/notifications`,
  UPDATE_NOTIFICATION: (id) => `${API_BASE_URL}/manager/notifications/${id}`,
};

// Kitchen endpoints - BE/Routes/KitchenRouters.js
export const KITCHEN = {
  ORDERS: `${API_BASE_URL}/kitchen/orders`,
  MARK_PREPARED: (id) => `${API_BASE_URL}/kitchen/orderitem/${id}/prepared`,
};

// Admin endpoints - BE/Routes/AdminRouters.js
export const ADMIN = {
  // User management
  USER_ADD: `${API_BASE_URL}/useradd`,
  GET_USER: `${API_BASE_URL}/getuser`,
  UPDATE_USER: (id) => `${API_BASE_URL}/updateuser/${id}`,
  DELETE_USER: (id) => `${API_BASE_URL}/deleteuser/${id}`,
  USER_COUNT: `${API_BASE_URL}/usercount`,

  // Category management - Note: GET_CATEGORY is public (no auth)
  ADD_CATEGORY: `${API_BASE_URL}/addcategory`,
  GET_CATEGORY: `${API_BASE_URL}/getcategory`,
  UPDATE_CATEGORY: (id) => `${API_BASE_URL}/updateCategory/${id}`, // Note: capital C in backend
  DELETE_CATEGORY: (id) => `${API_BASE_URL}/deleteCategory/${id}`, // Note: capital C in backend

  // Menu management
  ADD_MENU: `${API_BASE_URL}/addmenu`,
  GET_MENU: `${API_BASE_URL}/getmenu`,
  UPDATE_MENU: (id) => `${API_BASE_URL}/updatemenu/${id}`,
  DELETE_MENU: (id) => `${API_BASE_URL}/deletemenu/${id}`,

  // Table management
  ADD_TABLE: `${API_BASE_URL}/addtable`,
  GET_TABLE: `${API_BASE_URL}/gettable`,
  UPDATE_TABLE: (id) => `${API_BASE_URL}/updatetable/${id}`,
  DELETE_TABLE: (id) => `${API_BASE_URL}/deletetable/${id}`,
  GENERATE_QR: `${API_BASE_URL}/generateqr`,

  // Order management
  ADD_ORDER: `${API_BASE_URL}/addorder`,
  GET_ORDER: `${API_BASE_URL}/getorder`,
  UPDATE_ORDER: (id) => `${API_BASE_URL}/updateorder/${id}`,
  DELETE_ORDER: (id) => `${API_BASE_URL}/deleteorder/${id}`,
  SALES_REPORT: `${API_BASE_URL}/sales-report`,

  // Payment management
  ADD_PAYMENT: `${API_BASE_URL}/addpayment`,
  GET_PAYMENT: `${API_BASE_URL}/getpayment`,
  UPDATE_PAYMENT: (id) => `${API_BASE_URL}/updatepayment/${id}`,
  DELETE_PAYMENT: (id) => `${API_BASE_URL}/deletepayment/${id}`,
};

// Common endpoints
export const COMMON = {
  GET_CATEGORY: `${API_BASE_URL}/getcategory`,
  UPLOADS: `${API_BASE_URL}/uploads`,
};

export default API_BASE_URL;
